import { getStorageClasses } from '@/pages/clusters/pages/Workload/api/volume.api';
import get from 'lodash/get';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

export const useStorageClassOptions = (cluster: string) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  const swrKey = { key: 'Workload.StorageClassOptions', cluster };
  const {
    data: response,
    isLoading,
    isValidating,
  } = useSWR(swrKey, ({ cluster }) => getStorageClasses(cluster));

  useEffect(() => {
    if (response) {
      const items = get(response, 'items', []);
      const names = items.map((s) => {
        const name = get(s, 'metadata.name');
        return {
          label: name,
          value: name,
        };
      });
      setOptions(names);
    }
  }, [response]);

  return {
    options,
    loading: isLoading || isValidating,
  };
};
